module.exports = "/img/campaigns/intent-support-tooltip.png?ce9ef26f15e2a621a51d90878cc39aa3";